import React from 'react';

import { Flex } from '../../../components/Flex';
import { AtiraLinkContentBasic } from '../components/AtiraLinkContentBasic';
import { AtiraLinkContentCustomLinks } from '../components/AtiraLinkContentCustomLinks';
import { AtiraLinkContentEmbed } from '../components/AtiraLinkContentEmbed';
import { AtiraLinkContentLink } from '../components/AtiraLinkContentLink';
import { AtiraLinkContentProfile } from '../components/AtiraLinkContentProfile';
import { AtiraLinkContentSocials } from '../components/AtiraLinkContentSocials';

export const AtiraLinkContentTab: React.FC = () => {
  return (
    <Flex flexDirection="column" gap="l" flex={1}>
      <AtiraLinkContentLink />
      <AtiraLinkContentProfile />
      <AtiraLinkContentBasic />
      <AtiraLinkContentCustomLinks />
      <AtiraLinkContentEmbed />
      <AtiraLinkContentSocials />
    </Flex>
  );
};
